
// Swiper Slider Settings

document.addEventListener('DOMContentLoaded', function () {
  function destroySwiper(swiper) {
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
    }
  }

  function generateUniqueId() {
    return 'swiper-' + Math.random().toString(36).substr(2, 9);
  }

  function initSwiper(slider) {
    var desktopColumns = parseInt(slider.getAttribute('desktop-column'));
    var tabletColumns = parseInt(slider.getAttribute('tablet-column'));
    var mobileColumns = parseInt(slider.getAttribute('mobile-column'));
    var enablePagination = slider.getAttribute('pagination');
    var enableArrows = slider.getAttribute('arrows');
    var enableScrollbar = slider.getAttribute('scrollbar');
    var enableAutoplay = slider.getAttribute('autoplay') === 'true';
    var autoplayDelay = parseInt(slider.getAttribute('slider-delay'));
    var enableLoop = slider.getAttribute('loop') === 'true';
    var sliderSpaceBetween = parseInt(slider.getAttribute('slider-space-between'));

    var paginationId = generateUniqueId();
    var nextArrowId = generateUniqueId();
    var prevArrowId = generateUniqueId();
    var scrollbarId = generateUniqueId();

    var paginationEl = slider.querySelector('.swiper-pagination');
    var nextArrowEl = slider.querySelector('.swiper-button-next');
    var prevArrowEl = slider.querySelector('.swiper-button-prev');
    var scrollbarEl = slider.querySelector('.swiper-scrollbar');

    if (enablePagination && paginationEl) {
      paginationEl.id = paginationId;
    }
    if (enableArrows && nextArrowEl && prevArrowEl) {
      nextArrowEl.id = nextArrowId;
      prevArrowEl.id = prevArrowId;
    }
    if (enableScrollbar && scrollbarEl) {
      scrollbarEl.id = scrollbarId;
    }

    return new Swiper(slider, {
      slidesPerView: mobileColumns,
      spaceBetween: sliderSpaceBetween,
      pagination: enablePagination && paginationEl ? { el: `#${paginationId}`, clickable: true } : false,
      navigation: enableArrows && nextArrowEl && prevArrowEl ? {
        nextEl: `#${nextArrowId}`,
        prevEl: `#${prevArrowId}`,
      } : false,
      scrollbar: enableScrollbar && scrollbarEl ? { el: `#${scrollbarId}`, draggable: true } : false,
      autoplay: enableAutoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
      } : false,
      loop: enableLoop,
      breakpoints: {
        1025: {
          slidesPerView: desktopColumns,
        },
      
        768: {
          slidesPerView: tabletColumns,
        },
      },
    });
  }

  function loadSliders() {
    var sections = document.querySelectorAll('[id^="section-"]');
    
    sections.forEach(function (section) {
      var sliders = section.querySelectorAll('.swiper-desktop-and-mobile, .swiper-desktop, .swiper-mobile');
      
      sliders.forEach(function (slider) {
        var isDesktop = window.matchMedia('(min-width: 768px)').matches;
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var currentSwiper = slider.swiper;

        destroySwiper(currentSwiper);

        if (
          (slider.classList.contains('swiper-desktop-and-mobile')) ||
          (slider.classList.contains('swiper-desktop') && isDesktop) ||
          (slider.classList.contains('swiper-mobile') && isMobile)
        ) {
          slider.swiper = initSwiper(slider);
        }
      });
    });
  }

  function resizeSliders() {
    window.addEventListener('resize', function () {
      loadSliders();
    });
  }

  loadSliders();
  resizeSliders();
});


// Thumbail Slider for Bundle Feature Product
function initSwiperSliderForBundleFeatureProduct(element){
  var swiper = new Swiper(element, {
    slidesPerView: 1,
    effect: 'fade',
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
}

document.addEventListener('DOMContentLoaded', ()=>{
  const AllBundleFeatureProduct = document.querySelectorAll('.js-product-media-items');
  if(AllBundleFeatureProduct.length > 0){
    AllBundleFeatureProduct.forEach(bundleProduct=>{
      initSwiperSliderForBundleFeatureProduct(bundleProduct);
    })
  }
})


document.addEventListener('DOMContentLoaded', function() {
    const tabButtons = document.querySelectorAll('.bundle-tab__button');
    const tabContents = document.querySelectorAll('.bundle-tab__content');

    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Remove active class from all buttons and contents
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));

        // Add active class to clicked button and corresponding content
        button.classList.add('active');
        const tabContent = document.querySelector(`[data-tab-content="${button.dataset.tab}"]`);
        tabContent.classList.add('active');
      });
    });
  });

const bundleForms = document.querySelectorAll('[data-bundle-form]');    
bundleForms.forEach(form => {
  form.addEventListener('click', function(e) {
    e.preventDefault();

    const variant_id = form.querySelector('input[name="id"]').value;
    const quantity = parseInt(form.querySelector('input[name="quantity"]').value);
    const selling_plan = form.querySelector('input[name="selling_plan"]').value;
    // const plan_discount = form.querySelector('input[name="discount_value"]').value;
    
    const submitButton = form.querySelector('[data-bundle-submit]');
    const originalText = submitButton.innerHTML;
    submitButton.innerHTML = 'Adding...';
    submitButton.disabled = true;   

    window.location.href = `/cart/add?items[][id]=${variant_id}&items[][quantity]=${quantity}&items[][selling_plan]=${selling_plan}&return_to=/checkout`;
  });
});


// Accordion settings

var headings = document.querySelectorAll('.accordion summary');

headings.forEach(function(heading) {
  heading.addEventListener('click', function(event) {
    event.preventDefault();

    var description = this.nextElementSibling;
    if (description.classList.contains('show')) {
      description.style.maxHeight = description.scrollHeight + "px"; 
      setTimeout(function() {
        description.style.maxHeight = '0'; 
      }, 10);

      description.classList.remove('show');
    } else {
      description.classList.add('show'); 
      description.style.maxHeight = '0';

      setTimeout(function() {
        description.style.maxHeight = description.scrollHeight + "px"; 
      }, 10); 

      this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });
});





// Popup

document.querySelectorAll('.custom-open-popup').forEach(button => {
    button.addEventListener('click', function() {
        const randomNum = this.id.split('-')[1];
        const popup = document.querySelector(`.popup-${randomNum}`);
        popup.classList.add('open');
      
        const video = popup.querySelector('video'); // Select the video inside the popup
        if (video) {
            video.play();
        }
    });
});

document.querySelectorAll('.custom-close-popup').forEach(button => {
    button.addEventListener('click', function() {
        const randomNum = this.getAttribute('data-popup');
        const popup = document.querySelector(`.popup-${randomNum}`);
        popup.classList.remove('open');
      
        const video = popup.querySelector('video');
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    });
});



// Review video

document.querySelectorAll('.play_video').forEach(button => {
    button.addEventListener('click', function() {
        const video = this.parentElement.querySelector('video');
        const parent = this.closest('.review_img_video');

        if (video) {
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
            video.addEventListener('play', function() {
                parent.classList.add('playing');
            });
            video.addEventListener('pause', function() {
                parent.classList.remove('playing');
            });
        } else {
            parent.classList.toggle('playing');
        }

        if (parent && !parent.classList.contains('played')) {
            parent.classList.add('played');
        }
    });
});






// Tabs

document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content');

    tabButtons.forEach(button => {
        button.addEventListener('click', function () {
            const tabId = this.getAttribute('data-tab');
            tabButtons.forEach(btn => btn.classList.remove('active'));
            tabContents.forEach(content => {
                content.classList.remove('active');
                content.style.display = 'none';
            });
            this.classList.add('active');
            const activeContent = document.getElementById(`tab-${tabId}`);
            activeContent.style.display = 'block';
            setTimeout(() => activeContent.classList.add('active'), 10);
        });
    });
});



// After / Before
// var MyComparison = new slimBeforeAfter();
// const tabButtonsnew = document.querySelectorAll('.tab-button');

// tabButtonsnew.forEach(function(button) {
//   button.addEventListener('click', function () {
//     MyComparison.refresh();
//   });
// });

// ------- Landing Page scrollToBundleFeature button -------
function scrollToBundleFeature() {
  const targetSection = document.querySelector('.bundle-feature-product');
  if (targetSection) {
    window.scroll({
      top: targetSection.offsetTop,
      behavior: 'smooth'
    });
  }
}

document.querySelectorAll('.offer-scroll-btn').forEach(btn => {
  btn.addEventListener('click', scrollToBundleFeature);
});

window.addEventListener('resize', () => {
  scrollToBundleFeature();
});


// Inject additional text in Recharge customer portal
const rc_login_ele = document.querySelector('.rc-login');
if(rc_login_ele){
  const additional_text = window.strings.recharge_customer_portal.additional_text;
  if(additional_text != '' || additional_text != null){
    const temp = `<span class="cs-additional-recharge-text" style="font-size: 14px;">${additional_text}</span>`;
    rc_login_ele.insertAdjacentHTML('beforeend', temp);
  }
}